<pfx-entity-header-base-data>
  <ng-template pfxTemplate="column">
    <div class="flex flex-col gap-2">
      @if (phone(); as phone) {
        <pfx-icon-with-text [icon]="icons.phone">
          <a [href]="'tel://' + phone"> {{ phone }}</a>
        </pfx-icon-with-text>
      }

      @if (mobile(); as mobile) {
        <pfx-icon-with-text [icon]="icons.mobile">
          <a [href]="'tel://' + mobile"> {{ mobile }}</a>
        </pfx-icon-with-text>
      }

      @if (email(); as email) {
        <pfx-icon-with-text [icon]="icons.email">
          <a [href]="'mailto:' + email"> {{ email }}</a>
        </pfx-icon-with-text>
      }
      @if (isDependent()) {
        <pfx-icon-with-text [icon]="icons.rating">
          <a
            [href]="surveyLink()"
            target="_blank"
          >
            NPS-Umfrage</a
          >
        </pfx-icon-with-text>
      }
    </div>
  </ng-template>
  <ng-template pfxTemplate="column">
    <div class="flex flex-col gap-2">
      <pfx-icon-with-text [icon]="icons.address"
        ><a
          [href]="addressLink()"
          target="_blank"
          >{{ address() }}</a
        >
      </pfx-icon-with-text>

      @if (isIndividual()) {
        <pfx-icon-with-text
          [icon]="icons.dateOfBirth"
          [text]="dateOfBirth()"
        ></pfx-icon-with-text>
      }
      @if (isInternalCaregiver()) {
        <pfx-icon-with-text [icon]="icons.team">
          <a
            [routerLink]="['/business-partner-center', team()?._id]"
            class="p-0 font-bold p-button-link"
          >
            {{ team()?.mainAddress?.name }}</a
          >
        </pfx-icon-with-text>
      }
    </div>
  </ng-template>

  <ng-template pfxTemplate="column">
    @if (notesWithSeparator(); as notes) {
      <div class="flex flex-col gap-2">
        <pfx-icon-with-text [icon]="icons.notes">
          <pfx-scroll-panel height="150px">
            {{ notes }}
          </pfx-scroll-panel>
        </pfx-icon-with-text>
      </div>
    }
  </ng-template>

  @if (showRatings() && isIndividual()) {
    <ng-template pfxTemplate="column">
      <div class="flex flex-col gap-2">
        <pfx-rating-summary [businessPartnerId]="businessPartnerId()"></pfx-rating-summary>
      </div>
    </ng-template>
  }
</pfx-entity-header-base-data>
